import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ha-main-component',
  templateUrl: './ha-main-component.component.html',
  styleUrls: ['./ha-main-component.component.css']
})
export class HaMainComponentComponent implements OnInit {
chiletogglevalue:boolean;

initvalue:boolean=false;
  constructor() { }
// 
  ngOnInit() {
  }
  displayNode(event){
    this.chiletogglevalue=event;
  }
}
